import { AvailableStructureSetView } from '~/domain/projections/views';

export interface ScanGrouping<T> {
    readonly bySeriesUid: ReadonlyMap<string, T[]>;
    readonly unattached: readonly T[];
}

export function groupByScan<T>(
    seriesUids: readonly string[],
    items: readonly T[],
    scanUidOf: (item: T) => string | undefined
): ScanGrouping<T> {
    const known = new Set(seriesUids);
    const bySeriesUid = new Map<string, T[]>(
        seriesUids.map((uid) => [uid, []])
    );
    const unattached: T[] = [];
    for (const item of items) {
        const uid = scanUidOf(item);
        const attached =
            uid !== undefined && known.has(uid)
                ? bySeriesUid.get(uid)
                : undefined;
        if (attached) {
            attached.push(item);
        } else {
            unattached.push(item);
        }
    }
    return { bySeriesUid, unattached };
}

export function groupStructureSetsByScan(
    seriesUids: readonly string[],
    structureSets: readonly AvailableStructureSetView[]
): ScanGrouping<AvailableStructureSetView> {
    return groupByScan(seriesUids, structureSets, (set) => set.imageSeriesUid);
}
